import { Modal } from "@components/atoms/Modal";
import LoginForm from "@components/organisms/LoginForm";
import React from "react";

type LoginModalProps = {
  isLoginModalOpen: boolean;
  setIsLoginModalOpen: (open: boolean) => void;
};

function LoginModal({
  isLoginModalOpen,
  setIsLoginModalOpen,
}: LoginModalProps) {
  return (
    <Modal
      isOpen={isLoginModalOpen}
      onClose={() => setIsLoginModalOpen(false)}
      title='Login / Signup'
    >
      <LoginForm onSuccess={() => setIsLoginModalOpen(false)} />
    </Modal>
  );
}

export default LoginModal;
